import {LayoutType} from "../const";

export default function getLeftSize(layoutWidth:number, layoutType?:LayoutType) {

    if (!layoutType) layoutType = gd.layout.type

    switch (layoutType) {

        case LayoutType.LEFT:

            if (layoutWidth>1400) return 'medium';
            if (layoutWidth>1100) return 'small';
            break;

        case LayoutType.TOP:
            // if (layoutWidth>1600) return 'big';
            if (layoutWidth>1400) return 'medium';
            if (layoutWidth>1100) return 'small';
            break;

        default:
            console.error("#9123897 wtf ???")

            if (layoutWidth>1600) return 'big';
            if (layoutWidth>1400) return 'medium';
            if (layoutWidth>1100) return 'small';
            break;

    }

    return 'min';
}
